import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-1mgfM",
  "use": "facebook-1mgfM-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"facebook-1mgfM\"><path fill-rule=\"evenodd\" d=\"M8.001.111C7.751.074 6.89 0 5.89 0 3.797 0 2.362 1.278 2.362 3.621V5.64H0V8.38h2.362v7.029h2.833V8.381h2.353l.36-2.741H5.196V3.89c0-.788.213-1.334 1.352-1.334h1.454V.111z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol